module.exports = __webpack_public_path__ + "static/media/bm.ec1620c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bm.svg
// module id = 68
// module chunks = 0